import React from 'react'
import Header from "../../../components/PrivateHeader/PrivateHeader"
import Hero from "../../../components/PrivateHero/PrivateHero"
import Programs from "../../../components/PrivatePrograms/PrivatePrograms"
import Academy from "../../../components/PrivateAcademy/PrivateAcademy"
import Goals from "../../../components/Goals/Goals"
import Journey from "../../../components/Journey/Journey"
import Testimonials from "../../../components/Testimonial/Testimonials"
import Contact from "../../../components/Contact/Contact"
import Newsletter from "../../../components/NewsLetter/Newsletter"
import Footer from "../../../components/Footer/Footer"

const HomePage = () => {
    return (
        <div>
            <Header />
            <Hero />
            <Programs />
            <Academy />
            <Goals />
            <Journey />
            <Testimonials />
            <Contact />
            <Newsletter />
            <Footer />
        </div>
    )
}

export default HomePage
